// NATIVE

// INSTALLED

// CUSTOM
import { Grid } from '@mui/material';
import InputField from '../../../formFields/InputField';
import TextAreaField from '../../../formFields/TextAreaField';
import AutocompleteField from '../../../formFields/autocompleteField';

/**
 * CreateArea component renders a form with input fields for creating an area.
 *
 * @param {object} props - The properties object.
 * @param {object} props.formField - The form field object containing the fields for the form.
 * @param {object} props.formField.name - The name field object.
 * @param {string} props.formField.name.name - The name of the name field.
 * @param {string} props.formField.name.label - The label for the name field.
 * @param {object} props.formField.description - The description field object.
 * @param {string} props.formField.description.name - The name of the description field.
 * @param {string} props.formField.description.label - The label for the description field.
 *
 * @returns {JSX.Element} The rendered CreateArea component.
 */
export const CreateTerminal = (props: any) => {
  const {
    formField: { name, description, typeTerminal },
  } = props;

  const terminal = [
    { label: 'documento', value: 'Documento' },
    { label: 'facial', value: 'Facial' },
  ];

  return (
    <div>
      <Grid>
        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
          <InputField
            name={name.name}
            label={name.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid>
        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
          <AutocompleteField
            options={terminal}
            name={typeTerminal.name}
            label={typeTerminal.label}
            element={typeTerminal.name}
          />
        </Grid>
      </Grid>
      <Grid>
        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
          <TextAreaField
            name={description.name}
            label={description.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
      </Grid>
    </div>
  );
};
